import { Directive, ElementRef, Input, OnInit } from '@angular/core';

import { Feature } from '../models';
import { FeatureManagementService } from '../services';

@Directive({
    selector: '[appRemoveIfCachedFeatureEnabled]',
    standalone: false
})
export class RemoveIfCachedFeatureEnabledDirective implements OnInit {
  @Input('appRemoveIfCachedFeatureEnabled') featureName: Feature;

  constructor(private readonly el: ElementRef,
    private readonly featureManagementService: FeatureManagementService) {
  }

  ngOnInit() {
    if (this.featureManagementService.getIsFeatureEnabledWithCaching(this.featureName)) {
      this.el.nativeElement.parentNode.removeChild(this.el.nativeElement);
    }
  }
}
